import React from 'react'
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import Sidebar from './Sidebar/Sidebar';
import Options from './Options/Options';
import ScrollPreview from './Scroll/ScrollPreview';
import CardPreview from './Card/CardPreview';
    
const ProjectLayout = () => {

    return (
        <>
            <div>

                <div>
                    <Navbar/>
                </div>

                <div>
                    <div className=''> <Sidebar/> </div>
                    <div className=''>
                        <ScrollPreview/>
                        <CardPreview/>
                    </div>
                    <div className=''> <Options/> </div>
                </div>

                <div>
                    <Footer/>
                </div>

            </div>
        </>
    )
}
    
export default ProjectLayout;